import { styled } from '@/styles/stitches.config';
import { ComposableStyledComponentProps } from '@/types/composable-styled-component';
import { ReactNode } from 'react';

interface StoryTextProps {
  children: ReactNode;
}

const StoryTextRoot = styled('div', {
  paddingBlock: '$2',
});

export const StoryTextP = styled('div', {
  color: 'var(--color-text-light)',
  fontSize: '$3',
  margin: 0,
  paddingInlineStart: 'var(--side-padding)',
  paddingInlineEnd: 'var(--side-padding)',
  lineHeight: '$3',

  '@bp6': {
    maxWidth: '45rem',
  },

  '@bp11': {
    marginInline: 'auto',
  },
});

export const StoryText = ({ children }: StoryTextProps) => (
  <StoryTextRoot>
    <StoryTextP>{children}</StoryTextP>
  </StoryTextRoot>
);

export const CenteredFullHeight = styled(StoryTextRoot, {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  minHeight: '90vh',
  paddingInlineStart: '$3',
  paddingInlineEnd: '$3',

  '@bp11': {
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export const CenteredStoryText = (props: ComposableStyledComponentProps<HTMLDivElement>) => {
  return (
    <CenteredFullHeight css={props.css}>
      <StoryText>{props.children}</StoryText>
    </CenteredFullHeight>
  );
};
